import { $t } from '@/i18n';
export default {
  withTitle: true,
  isTitleSlot: false,
  title: $t('k_ab346fdc'),
  type: 'modal',
  drawerPlacement: 'right',
  width: '600px',
  height: '600px',
  keyboard: true,
  mask: true,
  maskClosable: true,
  withFooter: true,
  withClosableIcon: true,
  keepAlive: false,
};
